import {
  AreaMeasurementDto,
  CoreEntityDto,
  CoreType,
  ExternalReference,
  OwnershipInfo,
  Properties
} from '@/interfaces/core.interface'
import { getRequestGateway, patchRequestGateway } from './api.service'
import { GeoJsonGeometry, GeoJsonPoint } from '@/interfaces/misc.interface'

export type PageDto<T> = {
  page: number
  pageSize: number
  numberOfItems: number
  numberOfPages: number
  items: T[]
}

export async function fetchCoreEntity(id: string, withGeojson: boolean): Promise<CoreEntityDto> {
  const endpoint = `/core/v2/core/${id}?withGeojson=${withGeojson}`
  const res = await getRequestGateway<CoreEntityDto>(endpoint, 5000, 3)
  return res.data
}

export type CoreEntityPageParams = {
  page: number
  pageSize: number
  type?: CoreType
  parentId?: string
  withGeojson?: boolean
  search?: string
}

export async function fetchCoreEntityPage(
  params: CoreEntityPageParams
): Promise<PageDto<CoreEntityDto>> {
  const urlParams = new URLSearchParams()
  urlParams.append('page', params.page.toString())
  urlParams.append('pageSize', params.pageSize.toString())
  if (params.type) urlParams.append('type', params.type)
  if (params.parentId) urlParams.append('parentId', params.parentId)
  if (params.withGeojson) urlParams.append('withGeojson', params.withGeojson.toString())
  if (params.search) urlParams.append('search', params.search)
  const endpoint = `/core/v2/core?${urlParams.toString()}`
  const res = await getRequestGateway<PageDto<CoreEntityDto>>(endpoint, 5000, 3)
  return res.data
}

export async function fetchCoreEntityParents(id: string): Promise<CoreEntityDto[]> {
  const endpoint = `/core/v2/core/${id}/parents`
  const res = await getRequestGateway<CoreEntityDto[]>(endpoint, 5000, 3)
  return res.data
}

export type UpdateCoreEntityDto = {
  type: CoreType
  active?: boolean
  displayName?: string
  externalReferences?: ExternalReference[]
  geometry?: GeoJsonGeometry
  label?: string
  labelTenant?: string
  location?: GeoJsonPoint
  measurements?: AreaMeasurementDto[]
  name?: string
  nameTenant?: string
  ownershipInfo?: OwnershipInfo
  parentId?: string
  properties: Properties
}

export async function updateCoreEntity(
  id: string,
  data: UpdateCoreEntityDto
): Promise<CoreEntityDto> {
  const path = `core/v2/core/${id}`
  const req = patchRequestGateway(path, data, null)
  return req.then((res) => res?.data)
}
